"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "manerba-del-garda": {
    "7f606a1e": [{
      "hkey": "f72fec34",
      "slug": "manerba-del-garda",
      "name": "Manerba del Garda",
      "primary": true,
      "skipSearch": false
    }],
    "balbiana": [{
      "hkey": "f72fec34",
      "slug": "manerba-del-garda",
      "name": "Manerba del Garda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c08bc393": [{
      "hkey": "f72fec34",
      "slug": "manerba-del-garda",
      "name": "Manerba del Garda",
      "primary": true,
      "skipSearch": false
    }],
    "gardoncino": [{
      "hkey": "f72fec34",
      "slug": "manerba-del-garda",
      "name": "Manerba del Garda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "652c9675": [{
      "hkey": "f72fec34",
      "slug": "manerba-del-garda",
      "name": "Manerba del Garda",
      "primary": true,
      "skipSearch": false
    }],
    "montinelle": [{
      "hkey": "f72fec34",
      "slug": "manerba-del-garda",
      "name": "Manerba del Garda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0a05b95a": [{
      "hkey": "f72fec34",
      "slug": "manerba-del-garda",
      "name": "Manerba del Garda",
      "primary": true,
      "skipSearch": false
    }],
    "pieve": [{
      "hkey": "f72fec34",
      "slug": "manerba-del-garda",
      "name": "Manerba del Garda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0daf950f": [{
      "hkey": "f72fec34",
      "slug": "manerba-del-garda",
      "name": "Manerba del Garda",
      "primary": true,
      "skipSearch": false
    }],
    "sorarolo": [{
      "hkey": "f72fec34",
      "slug": "manerba-del-garda",
      "name": "Manerba del Garda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;